const splitArrayBy = (array, splitBy) => {
	const split = [];
	split.push([]);
	for (const item of array) if (splitBy(item) && split[split.length - 1].length !== 0) split.push([]);
	else if (!splitBy(item)) split[split.length - 1].push(item);
	for (let i = 0; i < split.length; i++) if (split[i].length === 0) split.splice(i, 1);
	if (split.length === 0) return [[]];
	return split;
};
export { splitArrayBy };

//# sourceMappingURL=index123.js.map